import { useCallback } from 'react'
import * as Sentry from '@sentry/react'

import { useSetPlayerData } from '../../services/store/playerStore/playerActions'
import l10n from '../../components/i18n/I18N'
import { config } from '../../components/Init/Init'
import { usePlayerStore } from '../../services/store'
import { useStateValue } from '../../services/state/StateProvider'

export const useLoginPlayer = () => {
  const [_, dispatch] = useStateValue()

  const playerStore = usePlayerStore()
  const playerStatus = playerStore.use.status()

  const { setPlayerData } = useSetPlayerData()

  const loginPlayer = useCallback(
    data => {
      const playerData = {
        ...data,
        newRegistration: playerStatus === config.status.partial && config.suppressRegisterPopup
      }

      dispatch({
        type: 'setModal',
        modals: {
          login: {
            display: false
          }
        }
      })

      // if we're using sentry, update sentry user
      if (process.env.REACT_APP_ENABLE_SENTRY === 'true') {
        Sentry.setUser({ id: playerData.userId })
      }

      l10n.setLocale({
        isoLocale: `${playerData.loginUser.preferredLanguageCode}-${playerData.country}`,
        locales: config.locales,
        isLoggedIn: playerData.status === config.status.registered,
        generalLanguages: config.generalLanguages
      })

      setPlayerData(playerData)
    },
    [dispatch, playerStatus, setPlayerData]
  )

  return { loginPlayer }
}
